import { localizationService } from "../localization";
import { FacetRenderer } from "../rendering/renderable/Renderable";
import { Text } from "troika-three-text";
export class LabelRenderable extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.owner = owner;
        this.fadeOut = true;
    }
    destroy() {
        if (this.text) {
            this.text.geometry.dispose();
            if (!Array.isArray(this.text.material)) {
                this.text.material.dispose();
            }
            this.text = undefined;
        }
    }
    setVisible(visible) {
        if (this.text)
            this.text.visible = visible;
    }
    updateFacet(facet) {
        if (this.fadeOut !== facet.fadeOut) {
            this.destroy();
            this.fadeOut = facet.fadeOut;
        }
        if (!this.text) {
            this.text = new Text();
        }
        if (this.text) {
            this.text.text = localizationService.getTranslation(facet.text);
            this.text.textAlign = "center";
            this.text.anchorX = "center";
            this.text.anchorY = "middle";
            this.text.rotateY(Math.PI);
            this.text.gpuAccelerateSDF = true;
            this.text.sync();
        }
    }
    updateTransform(_boundingBoxMin, _boundingBoxMax) {
        if (this.text) {
            this.text.position.copy(this.owner.worldPosition);
            this.text.quaternion.copy(this.owner.worldOrientation);
            this.text.scale.copy(this.owner.worldScale);
        }
    }
}
